const Box = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="40"
      height="40"
      viewBox="0 0 551.852 551.852"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <g>
        <path
          d="M545.933,106.575l0.377-0.999L276.049,0L6.228,106.671l-0.881-0.35v0.684l-0.038,0.021l0.038,0.115v338.651
		l270.579,106.059l270.617-106.064V106.326L545.933,106.575z M275.797,20.755l91.666,32.829L117.578,150.6l-84.647-33.39
		L275.797,20.755z M266.281,527.927L164.94,487.013l-50.859-19.107l-89.396-35.267V134.737l88.499,34.909v74.49l7.887-2.202
		l5.33,7.324l7.421-1.732l7.187,7.592l6.272-2.161l10.125,10.041v-75.911l7.877,3.11l100.999,39.834V527.927L266.281,527.927z
		 M275.948,213.077l-98.808-38.983L420.832,75.33l100.504,40.944L275.948,213.077z M527.218,432.639l-241.612,95.288V230.032
		l241.589-95.301v297.901L527.218,432.639L527.218,432.639z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  )
}

export default Box
